import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BroadcastService } from '../../core/services/broadcast.service';
import { MemberApiService } from './member-api.service';
import { ServiceManagerBase } from '../common/service-manager-base';


@Injectable({
    providedIn: 'root'
})
export class MemberManagerService extends ServiceManagerBase
{
    constructor(private membersService: MemberApiService,
                protected broadcastService: BroadcastService)
    {
        super(broadcastService);
    }

    clearCache()
    {
    }

    addFavoriteImage(imageAssetId: number): Observable<any>
    {
        return this.membersService.addFavoriteImage(imageAssetId);
    }

    deleteFavoriteImage(imageAssetId: number): Observable<any>
    {
        return this.membersService.deleteFavoriteImage(imageAssetId);
    }
}
